<div class="cambiarPassword">

  <div class="panel">

    <div class=" espacio">
    </div>

    <div class="tarjeta">
      <div class="contenido">

        <div class="titulo">
          {{'CambiarPassword.Titulo' | translate}}
        </div>

        <div class="divisor48" *ngIf="!reiniciarPassword"></div>
        <div class="divisor32" *ngIf="reiniciarPassword"></div>

        <div class="mensaje" *ngIf="reiniciarPassword">
          {{'CambiarPassword.PasswordExpirado' | translate}}
          <div class="divisor32"></div>
        </div>

        <!-- Actual -->
        <div class="col-12" style="padding: 0px">

          <div class="floatLabel registro">
            <input  placeholder="" type="{{verPasswordActual ? 'text' : 'password'}}" id="passwordActual" class="form-control inputPassword" [(ngModel)]="datos.Actual" name="passwordActual"
                   #passwordActual="ngModel" required [ngClass]="{'is-filled':passwordActual.value }" autocomplete="nope">

            <label class="faeLabelInput">{{'CambiarPassword.PasswordActual' | translate}}</label>

            <button *ngIf="passwordActual.value" class="btnTimes passwordInput" (click)="datos.Actual = '';" onclick="Focus('passwordActual')" tabindex="-1">
              <span class="fa fa-times"></span>
            </button>

            <button class="btnVerPassword normal" (click)="verPasswordActual = !verPasswordActual" tabindex="-1">
              <span class="fa fa-eye" *ngIf="verPasswordActual"></span>
              <span class="fa fa-eye-slash" *ngIf="!verPasswordActual"></span>
            </button>

            <span class="textoError" [hidden]="passwordActual.valid || (!passwordActual.touched && !errorActivo)">
              {{'CambiarPassword.PasswordActualInvalido' | translate}}
            </span>

          </div>

        </div>

        <div class="divisor24"></div>

        <!-- Nuevo -->
        <div class="col-12" style="padding: 0px">

          <div class="floatLabel registro">
            <input  placeholder="" type="{{verPasswordNueva ? 'text' : 'password'}}" id="passwordNuevo" class="form-control inputPassword" [(ngModel)]="datos.Nuevo" name="passwordNuevo" [pattern]="this.sistemaService.usuario.expresionpassword"
                   #passwordNuevo="ngModel" required [ngClass]="{'is-filled':passwordNuevo.value }" autocomplete="nope">

            <label class="faeLabelInput">{{'CambiarPassword.PasswordNuevo' | translate}}</label>

            <button *ngIf="passwordNuevo.value" class="btnTimes passwordInput" (click)="datos.Nuevo = '';" onclick="Focus('passwordNuevo')" tabindex="-1">
              <span class="fa fa-times"></span>
            </button>

            <button class="btnVerPassword normal" (click)="verPasswordNueva = !verPasswordNueva" tabindex="-1">
              <span class="fa fa-eye" *ngIf="verPasswordNueva"></span>
              <span class="fa fa-eye-slash" *ngIf="!verPasswordNueva"></span>
            </button>

            <span class="textoError" [hidden]="passwordNuevo.valid || (!passwordNuevo.touched && !errorActivo)">
              {{sistemaService.usuario.comentarioexpresion}}
            </span>

          </div>

        </div>

        <div class="divisor24"></div>

        <!-- Confirmar nuevo -->
        <div class="col-12" style="padding: 0px">

          <div class="floatLabel registro">
            <input placeholder="" type="{{verPasswordRepetido ? 'text' : 'password'}}" id="passwordConfirmar" class="form-control inputPassword" [(ngModel)]="datos.Repetir" name="passwordConfirmar"
                   #passwordConfirmar="ngModel" required [ngClass]="{'is-filled':passwordConfirmar.value }" autocomplete="new-nope">

            <label>{{'CambiarPassword.RepetirPassword' | translate}}</label>

            <button *ngIf="passwordConfirmar.value" class="btnTimes passwordInput" (click)="datos.Repetir = '';" onclick="Focus('passwordConfirmar')" tabindex="-1">
              <span class="fa fa-times"></span>
            </button>

            <button class="btnVerPassword normal" (click)="verPasswordRepetido = !verPasswordRepetido" tabindex="-1">
              <span class="fa fa-eye" *ngIf="verPasswordRepetido"></span>
              <span class="fa fa-eye-slash" *ngIf="!verPasswordRepetido"></span>
            </button>

            <span class="textoError" [hidden]="datos.Repetir == datos.Nuevo || (!passwordConfirmar.touched && !errorActivo)">
              {{'CambiarPassword.PasswordDiferente' | translate}}
            </span>

          </div>

        </div>

        <div class="divisor32"></div>

        <!-- btn cambiar -->
        <div class="col-12 text-center">
          <button id="botonCambiarPassword" class="btn boton filled redondeado botonCambiaPassword" (click)="CambairPassword()">
            {{'CambiarPassword.CambiarPassword' | translate}}
          </button>
        </div>

        <div class="divisor8"></div>

        <!-- btn cancelar -->
        <div class="col-12 text-center">
          <button id="botonCancelar" class="btn boton redondeado botonCambiaPassword" (click)="Cancelar()">
            {{'Cancelar' | translate}}
          </button>
        </div>

      </div>
    </div>

    <div class=" espacio">
    </div>

  </div>

</div>


